/*
 *
 * Permissions constants
 *
 */

export const EDIT_PERMISSIONS = {
  // question related permissions
  QUESTION_ADD: 'EDIT_PERMISSIONS.QUESTION_ADD',
  QUESTION_DELETE: 'EDIT_PERMISSIONS.QUESTION_DELETE',
  QUESTION_REORDER: 'EDIT_PERMISSIONS.QUESTION_REORDER',
  QUESTION_REORDER_MOVE_INSIDE_GROUP:
    'EDIT_PERMISSIONS.QUESTION_REORDER_MOVE_INSIDE_GROUP',
  QUESTION_REORDER_MOVE_AFTER: 'EDIT_PERMISSIONS.QUESTION_REORDER_MOVE_AFTER',
  QUESTION_EDIT_PROMPT: 'EDIT_PERMISSIONS.QUESTION_EDIT_PROMPT',
  QUESTION_CHANGE_TYPE: 'EDIT_PERMISSIONS.QUESTION_CHANGE_TYPE',
  QUESTION_DUPLICATE: 'EDIT_PERMISSIONS.QUESTION_DUPLICATE',
  QUESTION_EDIT_ADL: 'EDIT_PERMISSIONS.QUESTION_EDIT_ADL',
  QUESTION_EDIT_RANKING: 'EDIT_PERMISSIONS.QUESTION_EDIT_RANKING',
  QUESTION_TOGGLE_EDIT_RANKING: 'EDIT_PERMISSIONS.QUESTION_TOGGLE_EDIT_RANKING',
  // answer related permissions
  ANSWER_ADD: 'EDIT_PERMISSIONS.ANSWER_ADD',
  ANSWER_DELETE: 'EDIT_PERMISSIONS.ANSWER_DELETE',
  ANSWER_EDIT: 'EDIT_PERMISSIONS.ANSWER_EDIT',
  ANSWER_EDIT_PROMPT: 'EDIT_PERMISSIONS.ANSWER_EDIT_PROMPT',
  ANSWER_REORDER: 'EDIT_PERMISSIONS.ANSWER_REORDER',
  ANSWER_EDIT_MEDIA: 'EDIT_PERMISSIONS.ANSWER_EDIT_MEDIA',
  ANSWER_EXCLUSIVE: 'EDIT_PERMISSIONS.ANSWER_EXCLUSIVE',
  ANSWER_SCREENING_ALLOWED: 'EDIT_PERMISSIONS.ANSWER_SCREENING_ALLOWED',
  ANSWER_SCREENING_QUOTA: 'EDIT_PERMISSIONS.ANSWER_SCREENING_QUOTA',
  ANSWER_VISIBILITY: 'EDIT_PERMISSIONS.ANSWER_VISIBILITY',
  UNCONDITIONAL_HIDE_ANSWER: 'EDIT_PERMISSIONS.UNCONDITIONAL_HIDE_ANSWER',
  UNCONDITIONAL_HIDE_ANSWER_RESTORE:
    'EDIT_PERMISSIONS.UNCONDITIONAL_HIDE_ANSWER_RESTORE',
  UNCONDITIONAL_HIDE_NODE: 'EDIT_PERMISSIONS.UNCONDITIONAL_HIDE_NODE',
  // conversational related permissions
  CONVERSATIONAL_ANSWER_ADD: 'EDIT_PERMISSIONS.CONVERSATIONAL_ANSWER_ADD',
  CONVERSATIONAL_ANSWER_DELETE: 'EDIT_PERMISSIONS.CONVERSATIONAL_ANSWER_DELETE',
  CONVERSATIONAL_ANSWER_EDIT: 'EDIT_PERMISSIONS.CONVERSATIONAL_ANSWER_EDIT',
  CONVERSATIONAL_ANSWER_REORDER:
    'EDIT_PERMISSIONS.CONVERSATIONAL_ANSWER_REORDER',
  // matrix cell related permissions
  MATRIX_TOGGLE_REQUIRED_CELL: 'EDIT_PERMISSIONS.MATRIX_TOGGLE_REQUIRED_CELL',
  // setting related permissions
  SETTING_RECALL: 'EDIT_PERMISSIONS.SETTING_RECALL',
  SETTING_CARRY_FORWARD: 'EDIT_PERMISSIONS.SETTING_CARRY_FORWARD',
  SETTING_CARRY_FORWARD_CONFIG: 'EDIT_PERMISSIONS.SETTING_CARRY_FORWARD_CONFIG',
  SETTING_CARRY_FORWARD_ADD_CONFIG:
    'EDIT_PERMISSIONS.SETTING_CARRY_FORWARD_ADD_CONFIG',
  SETTING_MEDIA: 'EDIT_PERMISSIONS.SETTING_MEDIA',
  SETTING_DECIMAL_LIMIT: 'EDIT_PERMISSIONS.SETTING_DECIMAL_LIMIT',
  SETTING_SIGN: 'EDIT_PERMISSIONS.SETTING_SIGN',
  SETTING_LIMITS: 'EDIT_PERMISSIONS.SETTING_LIMITS',
  SETTING_RATING_STARS: 'EDIT_PERMISSIONS.SETTING_RATING_STARS',
  SETTING_RANKING: 'EDIT_PERMISSIONS.SETTING_RANKING',
  SETTING_SHUFFLE: 'EDIT_PERMISSIONS.SETTING_SHUFFLE',
  SETTING_BATCH_ANSWERS: 'EDIT_PERMISSIONS.SETTING_BATCH_ANSWERS',
  SETTING_PREDEFINED_ANSWERS: 'EDIT_PERMISSIONS.SETTING_PREDEFINED_ANSWERS',
  SETTING_LIMIT_RANGE: 'EDIT_PERMISSIONS.SETTING_LIMIT_RANGE',
  SETTING_LIMIT_TEXT_LENGTH: 'EDIT_PERMISSIONS.SETTING_LIMIT_TEXT_LENGTH',
  SETTING_SLIDER_STEP: 'EDIT_PERMISSIONS.SETTING_SLIDER_STEP',
  SETTING_SLIDER_SHOW_VALUE: 'EDIT_PERMISSIONS.SETTING_SLIDER_SHOW_VALUE',
  SETTING_NONE_OF_THE_ABOVE: 'EDIT_PERMISSIONS.SETTING_NONE_OF_THE_ABOVE',
  SETTING_NONE_OF_THESE: 'EDIT_PERMISSIONS.SETTING_NONE_OF_THESE',
  SETTING_OTHER: 'EDIT_PERMISSIONS.SETTING_OTHER',
  SETTING_ADVANCED_LOGIC: 'EDIT_PERMISSIONS.SETTING_ADVANCED_LOGIC',
  SETTING_DISPLAY_LOGIC: 'EDIT_PERMISSIONS.SETTING_DISPLAY_LOGIC',
  SETTING_SHUFFLE_QUESTIONNAIRE:
    'EDIT_PERMISSIONS.SETTING_SHUFFLE_QUESTIONNAIRE',
  SETTING_AB_TEST_TYPE: 'EDIT_PERMISSIONS.SETTING_AB_TEST_TYPE',
  SETTING_AB_TEST_CONCEPT_NUMBER:
    'EDIT_PERMISSIONS.SETTING_AB_TEST_CONCEPT_NUMBER',
  SETTING_AB_TEST_DEFAULT_QUESTIONS:
    'EDIT_PERMISSIONS.SETTING_AB_TEST_DEFAULT_QUESTIONS',
  SETTING_AB_TEST_LIKELIHOOD_QUESTIONS:
    'EDIT_PERMISSIONS.SETTING_AB_TEST_LIKELIHOOD_QUESTIONS',
  SETTING_AB_TEST_ATTRIBUTES: 'EDIT_PERMISSIONS.SETTING_AB_TEST_ATTRIBUTES',
  SETTING_CONJOINT_TYPE: 'EDIT_PERMISSIONS.SETTING_CONJOINT_TYPE',
  SETTING_CONJOINT_MAX_SETS: 'EDIT_PERMISSIONS.SETTING_CONJOINT_MAX_SETS',
  SETTING_CONJOINT_EXCLUDED_SETS:
    'EDIT_PERMISSIONS.SETTING_CONJOINT_EXCLUDED_SETS',
  SETTING_VAN_WESTENDORP: 'EDIT_PERMISSIONS.SETTING_VAN_WESTENDORP',
  SETTING_VAN_WESTENDORP_QUESTIONS_ORDER:
    'EDIT_PERMISSIONS.SETTING_VAN_WESTENDORP_QUESTIONS_ORDER',
  SETTING_VAN_WESTENDORP_ALLOW_DECIMAL:
    'EDIT_PERMISSIONS.SETTING_VAN_WESTENDORP_ALLOW_DECIMAL',
  SETTING_VAN_WESTENDORP_LIMIT_PRICE:
    'EDIT_PERMISSIONS.SETTING_VAN_WESTENDORP_LIMIT_PRICE',
  SETTING_VAN_WESTENDORP_MNS_EXTENSION:
    'EDIT_PERMISSIONS.SETTING_VAN_WESTENDORP_MNS_EXTENSION',
  SETTING_MAXDIFF_MESSAGES: 'EDIT_PERMISSIONS.SETTING_MAXDIFF_MESSAGES',
  SETTING_BIPOLAR_STYLE: 'EDIT_PERMISSIONS.SETTING_BIPOLAR_STYLE',
  SETTING_APPEARANCE_STYLE: 'EDIT_PERMISSIONS.SETTING_APPEARANCE_STYLE',
  SETTING_APPEARANCE_INPUT_SIZE:
    'EDIT_PERMISSIONS.SETTING_APPEARANCE_INPUT_SIZE',
  SETTING_QUOTAS_SCREENING: 'EDIT_PERMISSIONS.SETTING_QUOTAS_SCREENING',
  SETTING_QUOTAS_SIMPLE: 'EDIT_PERMISSIONS.SETTING_QUOTAS_SIMPLE',
  SETTING_MINIMUM_RESPONSES: 'EDIT_PERMISSIONS.SETTING_MINIMUM_RESPONSES',
  SETTING_QUOTAS_ADVANCED: 'EDIT_PERMISSIONS.SETTING_QUOTAS_ADVANCED',
  SETTING_DISPLAY_SAME_PAGE: 'EDIT_PERMISSIONS.SETTING_DISPLAY_SAME_PAGE',
  SETTING_LOOP_AND_MERGE_WITH_CARRY_FORWARD:
    'EDIT_PERMISSIONS.SETTING_LOOP_AND_MERGE_WITH_CARRY_FORWARD',
  SETTING_LOOP_AND_MERGE_RANDOMIZE_LOOP:
    'EDIT_PERMISSIONS.SETTING_LOOP_AND_MERGE_RANDOMIZE_LOOP',
  SETTING_LOOP_AND_MERGE_MAX_LOOPS:
    'EDIT_PERMISSIONS.SETTING_LOOP_AND_MERGE_MAX_LOOPS',
  // group related permissions
  GROUP_SHUFFLE: 'EDIT_PERMISSIONS.GROUP_SHUFFLE',
  GROUP_DELETE: 'EDIT_PERMISSIONS.GROUP_DELETE',
  GROUP_DELETE_ALL: 'EDIT_PERMISSIONS.GROUP_DELETE_ALL',
  GROUP_ADD: 'EDIT_PERMISSIONS.GROUP_ADD',
  GROUP_REORDER: 'EDIT_PERMISSIONS.GROUP_REORDER',
  GROUP_QUESTIONS_SHUFFLE: 'EDIT_PERMISSIONS.GROUP_QUESTIONS_SHUFFLE',
  GROUP_QUESTIONS_MOVE: 'EDIT_PERMISSIONS.GROUP_QUESTIONS_MOVE',

  // AB related permissions
  AB_ATTRIBUTE_ADD: 'EDIT_PERMISSIONS.AB_ATTRIBUTE_ADD',
  AB_ATTRIBUTE_DELETE: 'EDIT_PERMISSIONS.AB_ATTRIBUTE_DELETE',
  AB_ATTRIBUTE_EDIT_PROMPT: 'EDIT_PERMISSIONS.AB_ATTRIBUTE_EDIT_PROMPT',
  AB_ATTRIBUTE_CONTENT_ADD: 'EDIT_PERMISSIONS.AB_ATTRIBUTE_CONTENT_ADD',
  AB_ATTRIBUTE_CONTENT_DELETE: 'EDIT_PERMISSIONS.AB_ATTRIBUTE_CONTENT_DELETE',
  AB_ATTRIBUTE_CONTENT_EDIT_PROMPT:
    'EDIT_PERMISSIONS.AB_ATTRIBUTE_CONTENT_EDIT_PROMPT',
  AB_ATTRIBUTE_CONTENT_EDIT_MEDIA:
    'EDIT_PERMISSIONS.AB_ATTRIBUTE_CONTENT_EDIT_MEDIA',
  AB_CONCEPT_ADD: 'EDIT_PERMISSIONS.AB_CONCEPT_ADD',
  AB_CONCEPT_DELETE: 'EDIT_PERMISSIONS.AB_CONCEPT_DELETE',
  AB_CONCEPT_EDIT_PROMPT: 'EDIT_PERMISSIONS.AB_CONCEPT_EDIT_PROMPT',
  // Van Westendorp related permissions
  VAN_WESTENDORP_ATTRIBUTE_CONTENT_ADD:
    'EDIT_PERMISSIONS.VAN_WESTENDORP_ATTRIBUTE_CONTENT_ADD',
  VAN_WESTENDORP_ATTRIBUTE_CONTENT_DELETE:
    'EDIT_PERMISSIONS.VAN_WESTENDORP_ATTRIBUTE_CONTENT_DELETE',
  VAN_WESTENDORP_ATTRIBUTE_CONTENT_EDIT_PROMPT:
    'EDIT_PERMISSIONS.VAN_WESTENDORP_ATTRIBUTE_CONTENT_EDIT_PROMPT',
  VAN_WESTENDORP_ATTRIBUTE_CONTENT_EDIT_MEDIA:
    'EDIT_PERMISSIONS.VAN_WESTENDORP_ATTRIBUTE_CONTENT_EDIT_MEDIA',
  VAN_WESTENDORP_CONCEPT_EDIT_PROMPT:
    'EDIT_PERMISSIONS.VAN_WESTENDORP_CONCEPT_EDIT_PROMPT',
  // Loop and Merge related permissions
  LOOP_AND_MERGE_ATTRIBUTE_ADD: 'EDIT_PERMISSIONS.LOOP_AND_MERGE_ATTRIBUTE_ADD',
  LOOP_AND_MERGE_ATTRIBUTE_DELETE:
    'EDIT_PERMISSIONS.LOOP_AND_MERGE_ATTRIBUTE_DELETE',
  LOOP_AND_MERGE_ATTRIBUTE_EDIT_PROMPT:
    'EDIT_PERMISSIONS.LOOP_AND_MERGE_ATTRIBUTE_EDIT_PROMPT',
  LOOP_AND_MERGE_CONCEPT_ADD: 'EDIT_PERMISSIONS.LOOP_AND_MERGE_CONCEPT_ADD',
  LOOP_AND_MERGE_CONCEPT_DELETE:
    'EDIT_PERMISSIONS.LOOP_AND_MERGE_CONCEPT_DELETE',

  // survey generic permissions
  PREVIEW_MODE_PERMISSION: 'PREVIEW_MODE_PERMISSION',
  TRANSLATIONS: 'EDIT_PERMISSIONS.TRANSLATIONS',
  SURVEY_NAME_EDIT: 'EDIT_PERMISSIONS.SURVEY_NAME_EDIT',
  SURVEY_CHANGE_TERMS: 'EDIT_PERMISSIONS.SURVEY_CHANGE_TERMS',
  SURVEY_CHANGE_LANGUAGE: 'EDIT_PERMISSIONS.SURVEY_CHANGE_LANGUAGE',
  SURVEY_EDIT_DISQUALIFICATION_RULES:
    'EDIT_PERMISSIONS.SURVEY_EDIT_DISQUALIFICATION_RULES',
  CREATE_THIRD_PARTY: 'CREATE_THIRD_PARTY',
  CREATE_TEMPLATE: 'CREATE_TEMPLATE',
  CREATE_CONVERSATIONAL: 'CREATE_CONVERSATIONAL',
  IMPORT_FROM_LIBRARY: 'IMPORT_FROM_LIBRARY',
  // conjoint related permissions
  CONJOINT_CONTENT_EDIT_PROMPT: 'EDIT_PERMISSIONS.CONJOINT_CONTENT_EDIT_PROMPT',
  CONJOINT_ATTRIBUTE_ADD: 'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_ADD',
  CONJOINT_ATTRIBUTE_REORDER: 'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_REORDER',
  CONJOINT_ATTRIBUTE_REMOVE: 'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_REMOVE',
  CONJOINT_ATTRIBUTE_EDIT_MEDIA:
    'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_EDIT_MEDIA',
  CONJOINT_ATTRIBUTE_NAME: 'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_NAME',
  CONJOINT_ATTRIBUTE_TYPE: 'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_TYPE',
  CONJOINT_ATTRIBUTE_SORTABLE: 'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_SORTABLE',
  CONJOINT_ATTRIBUTE_VALUE_ADD: 'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_VALUE_ADD',
  CONJOINT_ATTRIBUTE_VALUE_TEXT_EDIT:
    'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_VALUE_TEXT_EDIT',
  CONJOINT_ATTRIBUTE_VALUE_REORDER:
    'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_VALUE_REORDER',
  CONJOINT_ATTRIBUTE_VALUE_REMOVE:
    'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_VALUE_REMOVE',
  CONJOINT_ATTRIBUTE_VALUE_EDIT_MEDIA:
    'EDIT_PERMISSIONS.CONJOINT_ATTRIBUTE_VALUE_EDIT_MEDIA',
  // audience (distribution-link) permissions
  AUDIENCE_TOGGLE_DEMOGRAPHIC: 'EDIT_PERMISSIONS.AUDIENCE_TOGGLE_DEMOGRAPHIC',
  // Audience related permissions
  AUDIENCE_MODIFY_LANGUAGE: 'EDIT_PERMISSIONS.AUDIENCE_MODIFY_LANGUAGE',
  DISTRIBUTION_LINK_CREATE: 'EDIT_PERMISSIONS.DISTRIBUTION_LINK_CREATE',
  DRILLDOWN_EDIT: 'EDIT_PERMISSIONS.DRILLDOWN_EDIT',
  DRILLDOWN_DELETE: 'EDIT_PERMISSIONS.DRILLDOWN_DELETE',
  THEME_EDIT: 'EDIT_PERMISSIONS.THEME_EDIT',
  THEME_PROGRESS_BAR_EDIT: 'EDIT_PERMISSIONS.THEME_PROGRESS_BAR_EDIT',
  THEME_ADVANCED_SETTINGS: 'EDIT_PERMISSIONS.THEME_ADVANCED_SETTINGS',
  EDIT_ADL: 'EDIT_PERMISSIONS.EDIT_ADL',
  EDIT_IR_LOI: 'EDIT_PERMISSIONS.EDIT_IR_LOI',
  PEEQ_AUDIENCE_STATE: 'EDIT_PERMISSIONS.PEEQ_AUDIENCE_STATE',
  PEEQ_CHANGE_LANGUAGE: 'EDIT_PERMISSIONS.PEEQ_CHANGE_LANGUAGE',
  PEEQ_CHANGE_COUNTRY: 'EDIT_PERMISSIONS.PEEQ_CHANGE_COUNTRY',
  // Revisions
  SAVE_REVISION: 'EDIT_PERMISSIONS.SAVE_REVISION',
  // AI Builder
  AI_BUILDER: 'EDIT_PERMISSIONS.AI_BUILDER',
  // Hidden Variables
  HIDDEN_VARIABLES: 'EDIT_PERMISSIONS.HIDDEN_VARIABLES',
};

export const NAVIGATION_PERMISSIONS = {
  // survey navigation related permissions
  SUMMARY: 'NAVIGATION_PERMISSIONS.SUMMARY',
  AUDIENCE: 'NAVIGATION_PERMISSIONS.AUDIENCE',
  QUESTIONNAIRE: 'NAVIGATION_PERMISSIONS.QUESTIONNAIRE',
  SURVEY_SETTINGS: 'NAVIGATION_PERMISSIONS.SURVEY_SETTINGS',
  LINK_SHARE: 'NAVIGATION_PERMISSIONS.LINK_SHARE',
  TRANSLATIONS: 'NAVIGATION_PERMISSIONS.TRANSLATIONS',
  RESULTS: 'NAVIGATION_PERMISSIONS.RESULTS',
  CHECKOUT: 'NAVIGATION_PERMISSIONS.CHECKOUT',
  THIRD_PARTY_SETTINGS: 'NAVIGATION_PERMISSIONS.THIRD_PARTY_SETTINGS',
  ADVANCED_LOGIC_TAB: 'NAVIGATION_PERMISSIONS.ADVANCED_LOGIC_TAB',
  DISQUALIFICATION_RULES_TAB:
    'NAVIGATION_PERMISSIONS.DISQUALIFICATION_RULES_TAB',
  SURVEY_THEMING_TAB: 'NAVIGATION_PERMISSIONS.SURVEY_THEMING_TAB',
  HIDDEN_VARIABLES_TAB: 'NAVIGATION_PERMISSIONS.HIDDEN_VARIABLES_TAB',
  DISPLAY_LOGIC_TAB: 'NAVIGATION_PERMISSIONS.DISPLAY_LOGIC_TAB',
  ADVANCED_QUOTA_LOGIC_TAB: 'NAVIGATION_PERMISSIONS.ADVANCED_QUOTA_LOGIC_TAB',
};

export const VISIBILITY_PERMISSIONS = {
  CHECKOUT_BUTTON: 'VISIBILITY_PERMISSIONS.CHECKOUT_BUTTON',
  COST_DETAILS: 'VISIBILITY_PERMISSIONS.COST_DETAILS',
  FEASIBILITY_DETAILS: 'VISIBILITY_PERMISSIONS.FEASIBILITY_DETAILS',
  TRANSLATIONS: 'VISIBILITY_PERMISSIONS.TRANSLATIONS',
  INSIGHTS: 'VISIBILITY_PERMISSIONS.INSIGHTS',
  SHOW_EDIT_ADL: 'VISIBILITY_PERMISSIONS.SHOW_EDIT_ADL',
  SHOW_QUESTIONNAIRE_REVISIONS:
    'VISIBILITY_PERMISSIONS.SHOW_QUESTIONNAIRE_REVISIONS',
  CONVERSATIONAL_AI: 'VISIBILITY_PERMISSIONS.CONVERSATIONAL_AI',
  LOOP_AND_MERGE: 'VISIBILITY_PERMISSIONS.LOOP_AND_MERGE',
  AI_BUILDER: 'VISIBILITY_PERMISSIONS.AI_BUILDER',
  SHOW_UNCONDITIONAL_HIDE_ANSWER_BUTTON:
    'VISIBILITY_PERMISSIONS.SHOW_UNCONDITIONAL_HIDE_ANSWER_BUTTON',
  SHOW_UNCONDITIONAL_HIDE_ANSWER_RESTORE_BUTTON:
    'VISIBILITY_PERMISSIONS.SHOW_UNCONDITIONAL_HIDE_ANSWER_RESTORE_BUTTON',
  SHOW_HIDE_NODE_BUTTON: 'VISIBILITY_PERMISSIONS.SHOW_HIDE_NODE_BUTTON',
  SHOW_NODE_DISPLAY_LOGIC_BUTTON:
    'VISIBILITY_PERMISSIONS.SHOW_NODE_DISPLAY_LOGIC_BUTTON',
  SHOW_ANSWERS_DISPLAY_LOGIC_BUTTON:
    'VISIBILITY_PERMISSIONS.SHOW_ANSWERS_DISPLAY_LOGIC_BUTTON',
  SHOW_ROWS_DISPLAY_LOGIC_BUTTON:
    'VISIBILITY_PERMISSIONS.SHOW_ROWS_DISPLAY_LOGIC_BUTTON',
  SHOW_COLUMNS_DISPLAY_LOGIC_BUTTON:
    'VISIBILITY_PERMISSIONS.SHOW_COLUMNS_DISPLAY_LOGIC_BUTTON',
  SETTING_QUOTAS_ADVANCED: 'VISIBILITY_PERMISSIONS.SETTING_QUOTAS_ADVANCED',
  SETTING_QUOTAS_SIMPLE: 'VISIBILITY_PERMISSIONS.SETTING_QUOTAS_SIMPLE',
  SETTING_MINIMUM_RESPONSES: 'VISIBILITY_PERMISSIONS.SETTING_MINIMUM_RESPONSES',
  SHOW_EDIT_SURVEY_BUTTON: 'VISIBILITY_PERMISSIONS.SHOW_EDIT_SURVEY_BUTTON',
};
